import Player from 'xgplayer';

import I18n from '@/components/resources/dialog/Video/styles/.xgplayer/skin/controls/i18n.js';
import Play from './controls/play.js';
import Start from './controls/start.js';
import Poster from './controls/poster.js';
import Flex from './controls/flex.js';
import Volume from '@/components/resources/dialog/Video/styles/.xgplayer/skin/controls/volume.js';
import Definition from './controls/definition.js';
import Loading from './controls/loading.js';
import Progress from './controls/progress.js';
import Time from './controls/time.js';
import PlaybackRate from './controls/playbackRate.js';
import Reload from '@/components/resources/dialog/Video/styles/.xgplayer/skin/controls/reload.js';
import MemoryPlay from '@/components/resources/dialog/Video/styles/.xgplayer/skin/controls/memoryPlay';
import Enter from './controls/enter';
import ErrorControl from './controls/error.js';
import Skip from './controls/skip';

Player.useAll([
  I18n,
  Play,
  Start,
  Poster,
  Flex,
  Volume,
  Definition,
  Loading,
  Progress,
  Time,
  PlaybackRate,
  Reload,
  ErrorControl,
  MemoryPlay,
  Enter,
  Skip
]);
import './style/index.scss';
Player.install('xgplayer-skin-custom', () => {});
